module.exports = __webpack_public_path__ + "images/unit-icons/new/10x20.svg";